import emailjs from "@emailjs/browser";
import axios from "axios";
// Create an axios instance
export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

const sendgridTriggerTemplateIds = {
  "SABBATH_REQUEST": "d-370536564341488fb3704250bae1887b",
  "SABBATH_APPROVAL": "d-0c75f366cc52468fa649083e15c41343",
};
const sendgridFromEmailIds = {
  "SABBATH_REQUEST": "sabbath@graceanointing.org",
  "SABBATH_APPROVAL": "sabbath@graceanointing.org",
};
const sendgridFromEmailandName = {
  "SABBATH_REQUEST": { name: "Sabbath @ Grace Anointing Ministries", email: "sabbath@graceanointing.org" },
  "SABBATH_APPROVAL": { name: "Sabbath @ Grace Anointing Ministries", email: "sabbath@graceanointing.org" },
};
// Define template IDs for different email types
const emailJTemplateIds = {
  welcome: "TMP_Welcome",
  prayer: "TMP_Prayer_Request",
  prayerReply: "TMP_Prayer_Reply",
  prayerReplyMarian: "TMP_Prayer_Marian",
  contact: "TMP_Default",
  prayer_ga: "TMP_Default",
  SABBATH_REQUEST: "TMP_Sabbath_Request",
  SABBATH_APPROVAL: "TMP_Sabbath_Approval",
  retreat: "TMP_Retreat_Reg",
  retreatApproval: "TMP_Retreat_Approval",
  retreatCancel: "TMP_Default",
  default: "TMP_Default",
  TMP_Default: "TMP_Default",
  TMP_Waiver: "TMP_Waiver",
  TMP_Retreat_Registration: "TMP_Retreat_Registration",
};

const sendGridEmail = async (templateParams, type) => {
  try {
    templateParams.fromEmail = sendgridFromEmailandName[type].email || process.env.REACT_APP_SENDGRID_DEFAULT_FROM_EMAIL;
    templateParams.fromName = sendgridFromEmailandName[type].name || "Grace Anointing Ministries";
    templateParams.templateId = sendgridTriggerTemplateIds[type];
    console.log("********Sending email via backend...", templateParams);
    const response = await axiosInstance.post(`/sendEmail`, {
      params: templateParams,
    });
    console.log("Backend response:", response);
    console.log("Backend response:", response.status);

    if (response.status === 200 || response.status === 202) {
      console.log("Email sent successfully via backend!", response.data);
      return { success: true, status: response.status, text: response.text };
    } else {
      console.error("Backend email sending failed:", response.data);
      return { success: false, status: response.status, error: response.data };
    }
  } catch (error) {
    console.error("Error sending email via backend:", error);
    return { success: false, status: "error", error: error.message };
  }
}

export const sendEmail = async (formData, type, serviceID) => {
  console.log("sendEmail formData", formData);
  const { firstName, lastName, email, phone, message } = formData;
  const fullName = `${firstName || ""} ${lastName || ""}`.trim();
  let templateParams = {};  // Set parameters based on the type of email
  let selectedServiceId = serviceID
    ? serviceID
    : process.env.REACT_APP_EMAILJS_SERVICE_ID;
  switch (type) {
    case "welcome":
      selectedServiceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
      templateParams = {
        to_name: firstName || " " || lastName,
        phone: phone,
        from_name: "Grace Anointing Team",
        from_email: process.env.REACT_APP_EMAILJS_DEFAULT_EMAIL_ID,
        to_email: email,
        message: "Welcome",
      };
      break;
    case "prayer":
      templateParams = {
        to_name: fullName,
        phone: phone,
        from_name: "Grace Anointing Team",
        to_email: email,
        message: message,
      };
      break;
    case "prayerReply":
      templateParams = {
        to_name: fullName,
        to_email: email,
        replyMessage:
          formData.replyMessageInLang || formData.replyMessage || "",
      };
      break;
    case "prayerReplyMarian":
      templateParams = {
        to_name: fullName,
        to_email: email,
        messageFromMarian:
          formData.messageFromMarianInLang || formData.messageFromMarian || "",
      };
      break;
    case "contact":
      templateParams = {
        from_name: fullName,
        to_name: "Grace Anointing Team",
        to_email: process.env.REACT_APP_EMAILJS_DEFAULT_EMAIL_ID,
        from_email: email,
        phone: phone,
        preMessage:
          type === "contact"
            ? "Please read the below message and respond accordingly."
            : "Please pray for the below request.",
        message: message,
        subject: type === "contact" ? "Contact Request" : "Prayer Request",
      };
      break;
    case "prayer_ga": // not using
      templateParams = {
        from_name: fullName,
        to_name: "Grace Anointing Prayer Team",
        to_email: process.env.REACT_APP_EMAILJS_PRAYER_EMAIL_ID,
        from_email: email,
        phone: phone,
        preMessage:
          type === "contact"
            ? "Please read the below message and respond accordingly."
            : "Please pray for the below request.",
        message: message,
        subject: type === "contact" ? "Contact Request" : "Prayer Request",
      };
      break;

    case "SABBATH_REQUEST":
      selectedServiceId = process.env.REACT_APP_EMAILJS_SERVICE_ID_SABBATH;
      templateParams = {
        from_name: "Grace Anointing Sabbath Team",
        to_name: fullName,
        to_email: email,
        from_email: "sabbath@graceanointing.org",
        phone: phone,
        message: message,
      };
      break;

    case "SABBATH_APPROVAL":
      selectedServiceId = process.env.REACT_APP_EMAILJS_SERVICE_ID_SABBATH;
      templateParams = formData;
      break;
    case "retreat":
      templateParams = formData;
      break;
    case "retreatApproval":
      templateParams = formData;
      break;
    case "retreatCancel":
      templateParams = {
        from_name: "Grace Anointing Retreat Team",
        to_name: formData.fullName,
        to_email: formData.email,
        cc_email: formData.cc_email,
        from_email: "retreat@graceanointing.org",
        phone: "",
        subject: "Retreat Registration Status Changed to " + formData.status,
        message:
          "Your retreat registration for the Retreat " +
          formData.retreatName +
          " with Registration ID : " +
          formData.registrationID +
          " has been cancelled.",
      };
      break;
    case "default":
      templateParams = formData;
      break;
    case "TMP_Default":
      templateParams = formData;
      break;
    default:
      templateParams = formData;
      break;

  }

  // Copy all values from formData to templateParams
  // Copy all values from formData to templateParams, but don't overwrite existing values
  templateParams = { ...formData, ...templateParams };
  console.log("Final templateParams:", templateParams);

  // Decide whether to use SendGrid or EmailJS based on type
  if (sendgridTriggerTemplateIds[type]) {
    return await sendGridEmail(templateParams, type);
  } else {
    console.log("Using EmailJS to send email for type:", type);

    // Select the template ID based on type or use a default template
    let selectedTemplateId = emailJTemplateIds[type];

    console.log("Selected Template ID:", selectedTemplateId);

    console.log("selectedServiceId:", selectedServiceId);
    // Send the email via emailjs
    if (!selectedTemplateId) {
      selectedTemplateId = type;
    }
    console.log("Selected Template ID:", selectedTemplateId);
    console.log("templateParams:", templateParams);
    try {
      const response = await emailjs.send(
        selectedServiceId || process.env.REACT_APP_EMAILJS_SERVICE_ID,
        selectedTemplateId,
        templateParams,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );
      console.log("Email sent successfully!", response.status, response.text);
      return { success: true, status: response.status, text: response.text };
    } catch (error) {
      console.error("Email JS sending failed...");
      console.error(":", JSON.stringify(error));
      console.error(".................");
      const errorMessage = error && error.message ? error.message : JSON.stringify(error);
      console.error("Error details:", errorMessage);
      console.error(".................");
      // Optional: try extracting more detail
      if (error?.response?.status) {
        console.error("🔍 Status code:", error.response.status);
        console.error("🔍 Error text:", error.response.text || error.response.statusText);
      }
      return { success: false, error: errorMessage };
    }
  }
};

export const sendEmailNewsLetters = async (formData) => {
  try {
    console.log("********Sending email via backend...", formData);
    const response = await axiosInstance.post(`/subscription/send-newsletter`, {
      params: formData,
    });
    console.log("Backend response:", response);

    if (response.data.success) {
      console.log("Email sent successfully via backend!", response.data);
      return { success: true, data: response.data };
    } else {
      console.error("Backend email sending failed:", response.data);
      return { success: false, error: response.data };
    }
  } catch (error) {
    console.error("Error sending email via backend:", error);
    return { success: false, error: error.message };
  }
};
